/**
 * Client route builders. Centralized because `/tournaments` (the browse hub)
 * and `/t/:tid` (one tournament) are easy to confuse, and App.tsx ends in a
 * `<Route path="*">` catch-all — a wrong tournament URL renders the home page
 * instead of erroring, so a typo is invisible at runtime.
 */
export const tournamentPath = (tid: string): string => `/t/${tid}`;

/**
 * Which tournament the register-a-team form should open on. Named here rather
 * than inline at both ends because the builder and the reader sit in different
 * files, and a mismatch would not throw — the form would just quietly stop
 * preselecting anything.
 */
export const TOURNAMENT_PARAM = "tournament";

/** The register-a-team form, opened on a tournament when one is in hand. */
export const registerTeamPath = (tid?: string): string =>
  tid ? `/me/register?${TOURNAMENT_PARAM}=${encodeURIComponent(tid)}` : "/me/register";
